export var LOCAL_DIRECT_UPLOAD_URL = 'local://s3-direct-upload-skipped';
export function shouldSkipS3DirectUpload(url) {
    return url === LOCAL_DIRECT_UPLOAD_URL;
}
export function shouldUploadFileWithApi() {
    var workApiBaseUrl = process.env.workApiBaseUrl;
    if (!workApiBaseUrl)
        return false;
    try {
        var url = new URL(workApiBaseUrl);
        return ['localhost', '127.0.0.1', '0.0.0.0', '::1'].includes(url.hostname);
    }
    catch (_e) {
        return false;
    }
}
